import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "back-button-section" }
const _hoisted_3 = { class: "opportunity-header" }
const _hoisted_4 = { class: "header-top" }
const _hoisted_5 = { class: "header-left" }
const _hoisted_6 = { class: "header-info" }
const _hoisted_7 = { class: "opportunity-title" }
const _hoisted_8 = { class: "opportunity-meta" }
const _hoisted_9 = {
  key: 0,
  class: "meta-item meta-item--cui",
  title: "CUI"
}
const _hoisted_10 = {
  key: 1,
  class: "meta-item meta-item--caen",
  title: "CAEN"
}
const _hoisted_11 = {
  key: 2,
  class: "meta-item meta-item--address",
  title: "Adresă"
}
const _hoisted_12 = {
  class: "meta-item meta-item--owner",
  title: "Responsabil (Owner)"
}
const _hoisted_13 = { class: "two-column-layout" }
const _hoisted_14 = { class: "left-column" }
const _hoisted_15 = { class: "details-card" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "right-column" }
const _hoisted_18 = { class: "section-card" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "section-card" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "section-card" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = {
  key: 1,
  class: "no-opportunity"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_partenerForm = _resolveComponent("partenerForm")!
  const _component_CardContacts = _resolveComponent("CardContacts")!
  const _component_CardOpportunities = _resolveComponent("CardOpportunities")!
  const _component_CardActivity = _resolveComponent("CardActivity")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!

  return (_openBlock(), _createBlock(_component_DxScrollView, { class: "opportunity-details-container" }, {
    default: _withCtx(() => [
      (_ctx.partener)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_DxButton, {
                icon: "arrowleft",
                text: "Înapoi la listă",
                "styling-mode": "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
                class: "back-btn"
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "opportunity-icon" }, [
                    _createElementVNode("i", { class: "dx-icon-box" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.partener.Nume || ' fără nume'), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.partener.CUI)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "dx-icon-card" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.partener.CUI), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.partener.Caen)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "dx-icon-accountbox" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.partener.Caen), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.partener.Strada)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "dx-icon-map" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.partener.Strada), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_12, [
                        _cache[5] || (_cache[5] = _createElementVNode("i", { class: "dx-icon-user" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.partener.Owner || 'Fără agent'), 1)
                      ])
                    ])
                  ])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header-actions" }, null, -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", { class: "card-header-icon" }, [
                      _createElementVNode("i", { class: "dx-icon-doc" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Detalii Partener")
                  ], -1)),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_partenerForm, {
                      "partener-data": _ctx.partener,
                      "can-edit": _ctx.canEditParteneri,
                      onSaved: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh-data')))
                    }, null, 8, ["partener-data", "can-edit"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #10b981 0%, #34d399 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-event" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Contacte")
                  ], -1)),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_CardContacts, {
                      "partener-id": _ctx.partener?.ID
                    }, null, 8, ["partener-id"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-money" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Oportunități")
                  ], -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_CardOpportunities, {
                      "account-id": _ctx.partener?.ID
                    }, null, 8, ["account-id"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-header" }, [
                    _createElementVNode("div", {
                      class: "card-header-icon",
                      style: {"background":"linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%)"}
                    }, [
                      _createElementVNode("i", { class: "dx-icon-task" })
                    ]),
                    _createElementVNode("h3", { class: "card-header-title" }, "Activități")
                  ], -1)),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_CardActivity, {
                      "account-id": _ctx.partener?.ID
                    }, null, 8, ["account-id"])
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "no-opportunity-icon" }, [
              _createElementVNode("i", { class: "dx-icon-box" })
            ], -1),
            _createElementVNode("p", { class: "no-opportunity-text" }, "Niciun partener selectat", -1),
            _createElementVNode("p", { class: "no-opportunity-subtext" }, "Selectează un partener din listă pentru a vedea detaliile", -1)
          ]))]))
    ]),
    _: 1
  }))
}